'use client';

import { getProviders, signIn } from 'next-auth/react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';

function SignInClient() {
  const [providers, setProviders] = useState(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const setAuthProviders = async () => {
      const res = await getProviders();
      setProviders(res);
    };
    setAuthProviders();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter an email address.');
      return;
    }
    try {
      await signIn('email', { email, callbackUrl: '/profile' });
      toast.success('Magic link sent to your email.');
    } catch {
      toast.error('Failed to send magic link.');
    }
  };

  return (
    <div className="flex flex-col justify-center items-center text-center min-h-[calc(100vh-112px)] w-full">
      <div className="card">
        <div className="font-semibold text-2xl tracking-tighter mx-auto flex items-center gap-2">
          <h1>Log in to your account, log your reps.</h1>
        </div>

        {/* <div className=" mt-12 w-full max-w-lg sm:mt-10"> */}
        <div className="mt-12 max-w-lg sm:mt-10 mx-5 border border-accent rounded-lg">
          <div className="flex flex-col p-6">
            <h2 className="text-xl font-semibold leading-6 tracking-tighter">
              Login
            </h2>
            <p className="mt-1.5 text-sm font-medium text-white/50">
              Welcome back, enter your email to get a magical link.
            </p>
          </div>
          <div className="p-6 pt-0">
            <form onSubmit={handleLogin}>
              <label className="input validator">
                <svg
                  className="h-[1em] opacity-50"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <title>email</title>
                  <g
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    strokeWidth="2.5"
                    fill="none"
                    stroke="currentColor"
                  >
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </g>
                </svg>
                <input
                  type="email"
                  placeholder="trey@phish.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
              <div className="validator-hint hidden">
                Enter valid email address
              </div>

              <div className="mt-4 flex items-center justify-center gap-x-2">
                <button
                  className="btn btn-neutral btn-outline btn-wide text-white"
                  type="submit"
                >
                  Log in with Magic Link
                </button>
              </div>
            </form>

            {providers?.google && (
              <div className="flex flex-col items-center">
                <div className="my-4 text-center text-sm text-white/60">
                  Or Login with your Google Account
                </div>
                <button
                  type="button"
                  className="btn bg-white text-black border-[#e5e5e5]"
                  onClick={() => signIn('google', { callbackUrl: '/profile' })}
                >
                  <svg
                    aria-label="Google logo"
                    width="16"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <g>
                      <path d="m0 0H512V512H0" fill="#fff"></path>
                      <path
                        fill="#34a853"
                        d="M153 292c30 82 118 95 171 60h62v48A192 192 0 0190 341"
                      ></path>
                      <path
                        fill="#4285f4"
                        d="m386 400a140 175 0 0053-179H260v74h102q-7 37-38 57"
                      ></path>
                      <path
                        fill="#fbbc02"
                        d="m90 341a208 200 0 010-171l63 49q-12 37 0 73"
                      ></path>
                      <path
                        fill="#ea4335"
                        d="m153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55"
                      ></path>
                    </g>
                  </svg>
                  Login with Google
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignInClient;
